import AppWaldenViewDetailRoute from '../../walden-view/detail';

export default class AppServicesWaldenViewRefDetailRoute extends AppWaldenViewDetailRoute {
  parentModelRouteName = 'app.services.walden-view-ref';
}
